/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import ContractsIcon from 'assets/images/contracts/icon_download_contract.svg';
import { TipoContratoOptions } from 'services/tipo_contrato';
import ContractDate from 'components/atoms/contract_date';
import ContractsHeader from 'components/atoms/contracts_header';
import MapLink from 'components/atoms/map_link';
import Download from 'assets/images/download.svg';
import SetaDown from 'assets/images/seta_down.svg';
import SetaUp from 'assets/images/seta_up.svg';
import { Modal } from 'react-bootstrap';
import Capag from 'components/atoms/capag';
import moment from 'moment';
// import createTrack from 'services/actions/tracker_actions';
import ClipboardIcon from 'components/atoms/clipboard_icon';
import { Container, ModalHeader, ModalScroll } from './styles';
import ModalOrganDetails from '../modal_organ_details';

interface ContractItemProps {
  contract: any;
  toggleSelectContracts: (id: number, updateAll?: boolean) => void;
  isChecked: boolean;
  contractIndex: number;
}

const ContractItem = (props: ContractItemProps) => {
  const { contract, toggleSelectContracts, isChecked, contractIndex } = props;
  const [modalOrganDetailsOpened, setModalOrganDetailsOpened] = useState<boolean>(false);
  const [showModalContracts, setShowModalContracts] = useState<boolean>(false);
  const [BiddingInfoToggle, setBiddingInfoToggle] = useState<boolean>(false);
  const [openSection, setOpenSection] = useState<'none' | 'contracts' | 'more'>('none');

  const toggleMore = () => setOpenSection((s) => (s === 'more' ? 'none' : 'more'));

  const serviceName = TipoContratoOptions.find(
    (TipoContratoOption) =>
      contract?._source?.contratos[0]?.tipo_contrato_id === TipoContratoOption.value,
  )?.label;
  return (
    <Container>
      <div className="row">
        <div className="col-12 p-0">
          <div
            className={`card shadow bidding mb-5 ${
              isChecked ? 'bidding_selected' : 'd-print-none'
            }`}
          >
            <ContractsHeader
              biddingId={contract?._source?.id}
              biddingIndex={contractIndex}
              isChecked={isChecked}
              toggleSelectedBiddings={toggleSelectContracts}
            />
            <div className="card-body p-4">
              <div className="bidding-info mb-2 d-flex">
                <div className="text-left pr-0 mr-3 bidding-info-title font-weight-bold">
                  Objeto:
                </div>
                <div
                  className=""
                  dangerouslySetInnerHTML={{ __html: contract?._source?.objeto || '-' }}
                />
              </div>
              <hr />
              <div className="row mb-2 d-block d-lg-flex">
                <div className="col-lg-4 col-12 bidding-info d-flex">
                  <div className="p-0 bidding-info-title text-left font-weight-bold d-flex align-items-center">
                    Vigência:
                  </div>
                  <div className="d-flex align-items-center text-secondary ml-2">
                    {contract?._source?.contratos[0]?.vigencia_inicio && (
                      <ContractDate
                        date={contract?._source?.contratos[0]?.vigencia_inicio}
                        dateType=""
                      />
                    )}
                    {contract?._source?.contratos[0]?.vigencia_fim && (
                      <ContractDate
                        date={contract?._source?.contratos[0]?.vigencia_fim}
                        dateType="a"
                      />
                    )}
                  </div>
                </div>
                <div className="col-lg-8 col-12 d-flex align-items-center">
                  <div className="text-md-right pr-0 bidding-info-title font-weight-bold">
                    Orgão:
                  </div>
                  <button
                    type="button"
                    aria-label="Clique para ver licitações já realizadas por esse órgão."
                    data-balloon-pos="up"
                    className="databalloon btn btn-link p-0 text-left break-text border-0 d-flex align-items-center"
                    onClick={() => {
                      setModalOrganDetailsOpened(true);
                      // createTrack('Card ContractItem - Clicou no órgão', { fonte: contract?._source?.orgao.id });
                    }}
                  >
                    <div
                      className="ml-2"
                      dangerouslySetInnerHTML={{ __html: contract?._source?.orgao.nome || '-' }}
                    />
                    <i className="material-icons bidding-info-icon ml-1 mb-1">info</i>
                  </button>
                </div>
              </div>
              <div className="row mb-2 d-block d-lg-flex">
                <div className="col-lg-4 col-12 d-flex">
                  <div className="text-left p-0 bidding-info-title font-weight-bold d-flex align-items-center">
                    Cidade:
                  </div>
                  <div className="d-flex align-items-center">
                    <div
                      className="ml-2 text-secondary"
                      dangerouslySetInnerHTML={{
                        __html:
                          `${contract?._source?.orgao?.cidade} - ${contract?._source?.orgao?.estado}` ||
                          '-',
                      }}
                    />
                    <MapLink
                      address={`${contract?._source?.orgao?.endereco} ${contract?._source?.orgao?.cidade} ${contract?._source?.orgao?.estado}`}
                      source={contract._source}
                    />
                    {contract?._source?.public_body?.tem_capag === true &&
                      contract?._source?.public_body?.capag &&
                      contract?._source?.public_body?.capag.capag !== 'N.D.' && (
                        <Capag capag={contract?._source?.public_body.capag} />
                      )}
                  </div>
                </div>
                <div className="col-lg-8 col-12 d-flex align-items-center">
                  <div className="align-items-center justify-content-end p-0 bidding-info-title font-weight-bold d-flex">
                    Edital:
                  </div>
                  <div
                    className="ml-2 text-secondary"
                    dangerouslySetInnerHTML={{ __html: contract?._source?.edital || '-' }}
                  />
                </div>
              </div>
              <div className="row mb-2 d-block d-lg-flex">
                <div className="col-lg-4 col-12 d-flex">
                  <div className="text-left p-0 bidding-info-title font-weight-bold d-flex align-items-center">
                    Valor Estimado:
                  </div>
                  <div className="estimated ml-2 d-flex align-items-center">
                    {contract?._source?.valor_estimado > 0 ? (
                      <div
                        className="font-weight-bold"
                        dangerouslySetInnerHTML={{
                          __html:
                            contract?._source?.valor_estimado.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            }) || '-',
                        }}
                      />
                    ) : (
                      '-'
                    )}
                  </div>
                </div>
                <div className="col-lg-8 col-12 d-flex align-items-center">
                  <div className="align-items-center justify-content-end p-0 bidding-info-title font-weight-bold d-flex">
                    Obs:
                  </div>
                  <div className="ml-2 text-secondary">
                    {contract?._source?.observacao || 'Sem Observação'}
                  </div>
                </div>
              </div>
              <button
                type="button"
                key="btn-bidding-more-info"
                className="btn btn-sm btn-link p-0 font-weight-bold text-decoration-none d-flex align-items-center"
                onClick={() => {
                  setBiddingInfoToggle(!BiddingInfoToggle);
                  toggleMore();
                }}
              >
                {BiddingInfoToggle
                  ? 'Ver menos informações do contrato'
                  : 'Ver mais informações do contrato'}

                {openSection === 'more' ? (
                  <img
                    className="px-2 nav-arrow mb-1"
                    alt="Ver todas as ferramentas"
                    src={SetaUp}
                  />
                ) : (
                  <img
                    className="px-2 nav-arrow mb-1"
                    alt="Ver todas as ferramentas"
                    src={SetaDown}
                  />
                )}
              </button>
              {openSection === 'more' && (
                <>
                  <hr />
                  <div className="m-2 py-2">
                    <div className="row mb-2 d-block d-lg-flex">
                      <div className="col-lg-4 col-12 d-flex align-items-center">
                        <div className="text-left pr-md-0 bidding-info-title font-weight-bold">
                          Tipo:
                        </div>
                        <div className="text-secondary ml-2">{serviceName}</div>
                      </div>
                      <div className="col-lg-8 col-12 d-flex align-items-center">
                        <div className="text-left pr-md-0 bidding-info-title font-weight-bold">
                          Receita ou Despesa:
                        </div>
                        <div className="text-secondary ml-2">
                          {contract?._source?.contratos[0]?.receita
                            ? contract?._source?.contratos[0]?.receita
                            : 'Despesa'}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2 d-block d-lg-flex">
                      <div className="col-lg-4 col-12 d-flex align-items-center">
                        <div className="text-left p-md-0 bidding-info-title font-weight-bold">
                          Fonte:
                        </div>
                        <div className="text-secondary ml-2">
                          {contract?._source?.contratos[0]?.fonte
                            ? contract?._source?.contratos[0]?.fonte
                            : '-'}
                        </div>
                      </div>
                      <div className="col-lg-8 col-12 d-flex align-items-center">
                        <div className="text-left pr-md-0 bidding-info-title font-weight-bold">
                          Id contrato PNCP:
                        </div>
                        <div className="text-secondary ml-2">
                          {contract?._source?.contratos[0]?.contrato_pncp_id
                            ? contract?._source?.contratos[0]?.contrato_pncp_id
                            : '-'}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2 d-block d-lg-flex">
                      <div className="col-lg-4 col-12 d-flex align-items-center">
                        <div className="text-left p-md-0 bidding-info-title font-weight-bold">
                          Data Fonte:
                        </div>
                        <div className="text-secondary ml-2">
                          <ContractDate
                            date={contract?._source?.contratos[0]?.data_publicacao}
                            dateType=""
                          />
                        </div>
                      </div>
                      <div className="col-lg-8 col-12 d-flex align-items-center">
                        <div className="text-left p-md-0 bidding-info-title font-weight-bold">
                          Id contratação PNCP:
                        </div>
                        <div className="text-secondary ml-2">
                          {contract?._source?.contratos[0]?.contratacao_pncp_id
                            ? contract?._source?.contratos[0]?.contratacao_pncp_id
                            : '-'}
                        </div>
                      </div>
                    </div>
                    <div className="row d-block d-lg-flex">
                      <div className="col-lg-4 col-12 d-flex align-items-center">
                        <div className="text-left p-md-0 bidding-info-title font-weight-bold">
                          Data da Assinatura:
                        </div>
                        <div className="d-flex align-items-center text-secondary ml-2">
                          <ContractDate
                            date={contract?._source?.contratos[0]?.data_assinatura}
                            dateType=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <hr className="mt-2 mb-2" />
              <span className="bidding-info-title font-weight-bold">Empresas contratadas:</span>
              <div className="contract-scroll-container mt-2">
                {contract?._source?.contratos.length > 0 &&
                  contract?._source?.contratos.map((contrato: any) => (
                    <div className="row mb-2 background-date p-2 bidding-info mx-0 d-block d-lg-flex">
                      <div className="col-lg-3 col-12 d-flex">
                        <div className="p-0 bidding-info-title font-weight-bold text-md-right d-flex align-items-center">
                          Valor:
                        </div>
                        <div className="estimated ml-2 d-flex align-items-center">
                          <span
                            className="px-2 text-center font-weight-bold"
                            dangerouslySetInnerHTML={{
                              __html:
                                contrato?.valor_contratado.toLocaleString('pt-br', {
                                  style: 'currency',
                                  currency: 'BRL',
                                }) || '-',
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-12 d-flex">
                        <div className="pr-0 bidding-info-title text-md-right font-weight-bold">
                          Empresa:
                        </div>
                        <div className="ml-2 d-flex text-secondary">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: contrato.nome_fornecedor || '-',
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-12 d-flex flex-wrap">
                        <div className="pr-0 bidding-info-title text-md-right font-weight-bold">
                          CNPJ:
                        </div>
                        <div className="ml-2 d-flex text-secondary">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: contrato.cpf_cnpj,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <hr className="mt-2 mb-2" />
              <span className="bidding-info-title font-weight-bold">Ações:</span>
              <div className="d-print-none mt-1">
                <button
                  className="btn btn-xs-block btn-sm btn-primary mr-1 mb-1"
                  type="button"
                  onClick={() => setShowModalContracts(!showModalContracts)}
                >
                  Contratos <img className="ml-1" alt="Download Icon" src={Download} />
                </button>
              </div>
              <hr className="mt-2 mb-2" />
              <div className="d-md-flex d-block justify-content-between">
                <div className="d-flex p-0 justify-content-center">
                  <div className="text-md-right p-md-0 bidding-info-title font-weight-bold ">
                    Nº Conlicitação:
                  </div>
                  <div className="bidding-info ml-2">{contract?._id}</div>
                  <ClipboardIcon
                    value={contract?._id.toString()}
                    action="Card Licitação - Copiar número conlicitacao"
                  />
                </div>
                <div className="d-flex justify-content-center">
                  <div className="text-secondary">
                    <span className="font-weight">Atualizada em: </span>
                    <span>{moment(contract?._source?.modified).format('L LT')}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModalContracts && (
        <Modal size="lg" show>
          <div className="modal-content border-0">
            <ModalHeader>
              <div className="modal-header text-white">
                <h5 className="modal-title">Contratos</h5>
                <button
                  type="button"
                  className="close text-white"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setShowModalContracts(false)}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </ModalHeader>
            <ModalScroll>
              <div className="contract-scroll-container">
                {showModalContracts && (
                  <div>
                    {contract?._source?.contratos_arquivos &&
                    contract._source.contratos_arquivos.length > 0 ? (
                      <>
                        {contract._source.contratos_arquivos.map((arquivo: any) => (
                          <div className="row backgroud-contracts py-3 d-md-flex align-items-center d-block mx-4 my-3 border rounded">
                            <div className="col-lg-6 col-12 text-center flex-wrap font-weight-bold">
                              {arquivo.document_title}
                            </div>
                            <div className="col-lg-3 col-12 text-center flex-wrap font-weight-bold">
                              {arquivo.publication_date_pncp}
                            </div>
                            <div className="col-lg-2 col-12 text-center flex-wrap font-weight-bold">
                              {arquivo.document_type_name}
                            </div>
                            <div className="col-lg-1 col-12 text-center flex-wrap text-center">
                              <a href={arquivo.url} download="arquivo">
                                <img alt="Download Icon" src={ContractsIcon} />
                              </a>
                            </div>
                          </div>
                        ))}
                      </>
                    ) : (
                      <div className="row alert alert-secondary justify-content-center mx-4 my-3">
                        O arquivo do contrato não foi encontrado.
                      </div>
                    )}
                  </div>
                )}
              </div>
            </ModalScroll>
          </div>
        </Modal>
      )}
      {modalOrganDetailsOpened && (
        <ModalOrganDetails
          contract={contract}
          setModalOrganDetailsOpened={setModalOrganDetailsOpened}
        />
      )}
    </Container>
  );
};
export default ContractItem;
